/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

// import p1 from 'assests/Photos/alumini/20-21/st1.jpg';
// import p2 from 'assests/Photos/alumini/20-21/st2.jpg';

const Content = () => {

  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/st1.webp`;
  const p2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/st2.webp`;
  

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const photos = [
    // {
    //   src: 'https://www.npsypr.com/images/events/2020-2021/alumni/st2.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
    // {
    //   src: 'https://www.npsypr.com/images/events/2020-2021/alumni/slide1.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
    // {
    //   src: 'https://www.npsypr.com/images/events/2020-2021/alumni/slide2.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
    // {
    //   src: 'https://www.npsypr.com/images/events/2020-2021/alumni/slide3.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Box>
      <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
      <Typography
          variant="h4"
          data-aos={'fade-up'}
          gutterBottom
          align='center'
          sx={{
            fontWeight: 700,
          }}
        >
          Alumni
        </Typography>
        <Typography variant='h4'>Alumni 2019 - 20</Typography>
        <br />
        <Typography variant={'subtitle1'} align='justify'>
        Creating an engaged, supportive alumni network is crucial to an institution's success. If communication stops once graduates leave an institution, they connect with the part of them will be lost. ... Good alumni relationships bring many benefits to both the institution and the alumni. We play an important role by representing the views of our members and contributing to building an engaged and supportive alumni community appropriate to a world class Educational Institution with Indian Ethos. We bring to life the brotherhood and the sense of belonging between old students who have walked towards their goals. We give our Alumnus a platform to come together, meet and share experiences which otherwise would have been difficult in their busy schedule.
        </Typography>
        <Grid >
          <LazyLoadImage

            height={'50%'}
            width={'50%'}
            
            src={p1}
            alt="Remote working"
            effect="blur"
            style={{
              filter:
                theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
              objectFit: 'cover',
              borderRadius: 6,
              width: '70%',
              height: '70%',
              
            }}
          />
          <LazyLoadImage
            height={'50%'}
            width={'50%'}
            src={p2}
            alt="Remote working"
            effect="blur"
            style={{
              filter:
                theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
              objectFit: 'cover',
              borderRadius: 6,
              width: '70%',
              height: '70%',
              
            }}
          />
        
        </Grid>
      </Box>
    </Box>
  );
};

export default Content;
